export function flattenOneLevel(arr: Array<any>) {
  return arr.reduce(
    (acc, val) => acc.concat(Array.isArray(val) ? val : [val]),
    [],
  );
}
